import { Button } from "primereact/button";
import { JVInput } from "../../shared/JVInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useRef, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Fetch } from "../../shared/Fetch";
import { Toast } from "primereact/toast";
import { IPermissionProps } from "../../models/Login";

interface IAddNotice {
    Notice_Heading: string,
    Notice: string,
}

export const AddNotice = (permissions: IPermissionProps) => {
    const [loading, setLoading] = useState(false);
    const [saveDis, setSaveDis] = useState(false);
    const [heading, setHeading] = useState("");
    const [notice, setNotice] = useState("");
    const toast = useRef<any>(null);

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if ((heading === "" && notice === "") || (heading === null && notice === null)) {
            toast.current?.show({ severity: 'error', detail: "Heading and Notice field is required", life: 3000 });
            setSaveDis(false);
        } else if (heading === "" || heading === null ) {
            toast.current?.show({ severity: 'error', detail: "Heading field is required", life: 3000 });
            setSaveDis(false);
        } else if (notice === "" || notice === null ) {
            toast.current?.show({ severity: 'error', detail: "Notice field is required", life: 3000 });
            setSaveDis(false);
        }  else {
            setLoading(true);
            const data: IAddNotice = {
                Notice_Heading: heading,
                Notice: notice,
            }
    
            saveToDB(data);
        }
    }

    const saveToDB = async (body: IAddNotice) => {
        const response = await Fetch("tbl_Notice", "POST", body, null, null);
        if (response) {
            onClear();
            toast.current?.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
            setSaveDis(false);
            setLoading(false);
        } else {
            setSaveDis(false);
            setLoading(false);
        }
    }

    const onClear = () => {
        setHeading("");
        setNotice("");
    }

    return (
        <>
            { permissions.is_Create && <form onSubmit={(e)=>onSubmit(e)} className="p-fluid formgrid grid">
                <div className="flex m-auto gap-3" style={{ width: "98%" }}>
                    <div className="flex flex-column w-6">
                        <label htmlFor="req_JobDescription">Heading:<span style={{ color: 'red' }}>*</span></label>
                        <CKEditor editor={ClassicEditor} data={heading} onChange={(event, editor) => { setHeading(editor.getData()); }} />
                    </div>
                    <div className="flex flex-column w-6">
                        <label htmlFor="req_JobDescription">Notice:<span style={{ color: 'red' }}>*</span></label>
                        <CKEditor editor={ClassicEditor} data={notice} onChange={(event, editor) => { setNotice(editor.getData()); }} />
                    </div>
                </div>
                <div className="col-12 md:col-12 flex gap-4 mt-5">
                    <Button className="field col md:col" label="SAVE" loading={loading} type="submit" disabled={saveDis}></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onClear} type="button"></Button>
                </div>
            </form>}
            <Toast ref={toast} />
        </>
    );
}